(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tsLuxon", [], factory);
	else if(typeof exports === 'object')
		exports["tsLuxon"] = factory();
	else
		root["tsLuxon"] = factory();
})(this, () => {
return 